import { jsx } from "react/jsx-runtime";
import { container, embed } from "./ResponsiveEmbed.css.mjs";
const ResponsiveEmbed = (props) => /* @__PURE__ */ jsx("div", { className: container, children: /* @__PURE__ */ jsx("iframe", { src: props.url, className: embed, allowFullScreen: true }) });
export {
  ResponsiveEmbed
};
